module.exports = __webpack_public_path__ + "img/Categories.9dd0f2f7.svg";